import { Routes } from '@angular/router';
import { AuthGuard } from './services/auth.guard';

import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { MasterDataComponent } from './components/master-data/master-data.component';
import { TrialInfoComponent } from './components/demos/trial-info/trial-info.component';
import { KycWizardComponent } from './components/demos/kyc-wizard/kyc-wizard.component';
import { KycPaymentComponent } from './components/demos/kyc-payment/kyc-payment.component';
import { PaymentStatusComponent } from './components/demos/kyc-payment/payment-status';
// import { SubscriptionComponent } from './components/subscription/subscription.component';
import { Communications } from './components/communications/communications';
import { InstListComponent } from './components/institute/inst-list/inst-list.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'autologin/:ekey', component: LoginComponent },
  { path: 'institute', component: InstListComponent },

  { path: 'dashboard/home', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'dashboard/:pg', component: DashboardComponent, canActivate: [AuthGuard] },

  { path: 'subpg', component: DashboardComponent, children: [
      { path: 'masters', component: MasterDataComponent },
      { path: 'communications', component: Communications }
      // { path: 'kyc', component: KycWizardComponent },
      // { path: 'subs', component: SubscriptionComponent }
    ], canActivate: [AuthGuard]
  },
  { path: 'careers', loadComponent: () => import('./modules/hr-admin/careers/careers').then(m => m.Careers) },
  { path: 'careers/:job_code', loadComponent: () => import('./modules/hr-admin/careers/careers').then(m => m.Careers) },

  { path: 'payment', component: KycPaymentComponent },
  { path: 'payment-status/:id', component: PaymentStatusComponent, canActivate: [AuthGuard] },
  // { path: 'staff/:id', component: StaffViewComponent, canActivate: [AuthGuard] },  
  // { path: 'trial', component: TrialInfoComponent },
  // { path: 'kyc', component: KycWizardComponent },
  { path: '**', redirectTo: 'login' }
];
